// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_math from "../../../../node_modules/rescript/lib/es6/js_math.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as GalleryButton$Showside from "./GalleryButton.bs.js";
function PhotoSliderThumbnails(Props) {
  var medias = Props.medias;
  var currentSlide = Props.currentSlide;
  var setSlideToIndex = Props.setSlideToIndex;
  var onClickThumbnail = Props.onClickThumbnail;
  var visibilityOpt = Props.visibility;
  var maxThumbnailsOpt = Props.maxThumbnails;
  var maxSlidesPerViewport = Props.maxSlidesPerViewport;
  var product = Props.product;
  var variantId = Props.variantId;
  var visibility = visibilityOpt !== undefined ? visibilityOpt : "always";
  var maxThumbnails = maxThumbnailsOpt !== undefined ? maxThumbnailsOpt : 10;
  var images = Belt_Array.keepMap(medias, function (item) {
    switch (item.TAG | 0) {
      case /* Image */0:
        return item._0.url;
      case /* Video */1:
        return item._0.posterUrl;
      case /* IframeEmbed */2:
        return;
    }
  });
  var partial_arg = images.length;
  var maxSlidesPerViewport$1 = Belt_Option.map(maxSlidesPerViewport, function (param) {
    return Math.min(partial_arg, param);
  });
  var maxHeight = Belt_Option.map(maxSlidesPerViewport$1, function (count) {
    return count * 48 + (Js_math.ceil(count) - 1 | 0) * 6;
  });
  var render = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-col gap-2")
    }, React.createElement(GalleryButton$Showside.make, {
      product: product,
      variantId: variantId
    }), Belt_Array.mapWithIndex(Belt_Array.keepWithIndex(images, function (src, idx) {
      return idx < maxThumbnails;
    }), function (idx, src) {
      var last = idx === (images.length - 1 | 0) || images.length > maxThumbnails && idx === (maxThumbnails - 1 | 0);
      var selected = Caml_obj.equal(idx, currentSlide) || Caml_obj.greaterthan(currentSlide, maxThumbnails - 1 | 0) && last;
      var delta = images.length - maxThumbnails | 0;
      return React.createElement(DataAttribute$Showside.make, {
        dataTestId: selected ? "photo-thumbnail-selected" : "photo-thumbnail",
        children: React.createElement("div", {
          className: CSS$Showside.prefix((images.length > 1 ? "opacity-100" : "opacity-0 pointer-events-none") + " inline-block transition-transform text-primary rounded overflow-hidden cursor-pointer relative w-16 h-16 border border-solid transform-gpu duration-150" + (selected ? " border-main ring-current ring-1 scale-105" : " border-transparent scale-100")),
          id: "photo-slider-thumbnails-" + String(idx) + "",
          tabIndex: 0,
          onClick: function (e) {
            Curry._1(setSlideToIndex, function (param) {
              return idx;
            });
            Curry._1(onClickThumbnail, undefined);
          }
        }, React.createElement(SmartImg$Showside.make, {
          src: src,
          fit: /* Cover */1,
          alt: product.name,
          priority: 1
        }), last && delta > 0 ? React.createElement("div", {
          className: CSS$Showside.prefix("bg-black bg-opacity-50 text-white flex items-center justify-center text-lg absolute inset-0")
        }, "+" + String(delta) + "") : null),
        key: src
      });
    }));
  };
  var stopTouchPropagation = React.useCallback(function (e) {
    e.stopPropagation();
  }, []);
  var scrollToRef = React.useRef(function (param) {});
  var scrollElementRef = React.useRef(null);
  React.useEffect(function () {
    if (maxHeight !== undefined && currentSlide !== undefined) {
      var thumbEl = Belt_Option.flatMap(Caml_option.nullable_to_opt(scrollElementRef.current), function (__x) {
        return Caml_option.nullable_to_opt(__x.querySelector("#photo-slider-thumbnails-" + String(currentSlide)));
      });
      var thumbOffsetTop = Belt_Option.map(Belt_Option.map(Belt_Option.flatMap(thumbEl, function (prim) {
        return prim;
      }), function (prim) {
        return prim.offsetTop;
      }), function (prim) {
        return prim;
      });
      var thumbHeight = Belt_Option.map(Belt_Option.map(thumbEl, function (prim) {
        return prim.clientHeight;
      }), function (prim) {
        return prim;
      });
      var containerHeight = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(scrollElementRef.current), 0, function (el) {
        return el.clientHeight;
      });
      if (thumbOffsetTop !== undefined && thumbHeight !== undefined) {
        Curry._1(scrollToRef.current, {
          TAG: /* Pixel */1,
          _0: thumbOffsetTop + (thumbHeight / 2 - containerHeight / 2)
        });
      }
    }
  }, [currentSlide, maxHeight]);
  var getWrapperStyle = function (maxHeight) {
    return {
      height: "" + String(maxHeight + 6) + "px",
      width: "" + String(60) + "px"
    };
  };
  var tmp = {
    className: CSS$Showside.prefix(Cn.make(["relative", visibility === "hover" ? "transition-opacity duration-150 group-hover:opacity-100 opacity-0" : ""]))
  };
  var tmp$1 = maxHeight !== undefined ? Caml_option.some(getWrapperStyle(maxHeight)) : undefined;
  if (tmp$1 !== undefined) {
    tmp.style = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement("div", tmp, maxHeight !== undefined ? React.createElement(Scrollable$Showside.make, {
    scrollToRef: scrollToRef,
    children: render(undefined),
    fwdRef: scrollElementRef,
    className: CSS$Showside.prefix("p-1 pr-2"),
    onTouchStart: stopTouchPropagation,
    onTouchMove: stopTouchPropagation,
    onTouchEnd: stopTouchPropagation,
    style: getWrapperStyle(maxHeight)
  }) : render(undefined));
}
PhotoSliderThumbnails.displayName = "PhotoSliderThumbnails";
var make = PhotoSliderThumbnails;
export { make };
/* react Not a pure module */